import { AbstractControl } from '@angular/forms';
import { ErrorMessage } from '../constants/error-message.constants';
import { Regex } from '../constants/regex.constants';

export function passwordValidator(control: AbstractControl): { password: any } | null {
    if (control.value !== '' && !Regex.Password.test(control.value)) {
        return {
            password: { message: ErrorMessage.password }
        };
    }

    return null;
}

export function strictPasswordValidator(control: AbstractControl): { password: any } | null {
    if (control.value !== '' && !Regex.StrictPassword.test(control.value)) {
        return {
            password: { message: ErrorMessage.passwordRequirementsNotMet }
        };
    }

    return null;
}
